module.exports = __webpack_public_path__ + "static/media/11-Y.2b2dc58b.mp3";